/**
 * Every editable form, not just contenteditable="true": the attribute is also editable
 * when empty or set to "plaintext-only", and only "false" turns it off.
 *
 * Shared by the board-focus controller (which elements may keep their focus) and the
 * paste handler (whether a paste belongs to an editor rather than to the board).
 */
export const EDITABLE_SELECTOR = '[contenteditable]:not([contenteditable="false"])';

/**
 * Whether `target` is an editable element or sits INSIDE one.
 *
 * Unlike `isEditableTarget` (which reads `isContentEditable` of the target itself), this
 * also matches a non-editable island inside an editor — e.g. the textbox editor's
 * `contenteditable="false"` link-icon widget. A paste addressed to such an island still
 * belongs to the editor, not to the board (Anke, 2026-10-02: text pasted into a textbox
 * sometimes ALSO landed on the board as an image — trigger not reproduced, this is a
 * safeguard).
 *
 * Deliberately unbounded (not cut off at the board root), the same reach the inherited
 * `isContentEditable` already has.
 */
export function isInsideEditable(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest(EDITABLE_SELECTOR) !== null;
}
